import { useEffect, useState } from "react";
import { useSelect } from "./useSelect";
import { PosVendor } from "../types";

const SYNCABLE_POS_VENDORS: PosVendor[] = [
    PosVendor.foodics,
    PosVendor.feedus,
    PosVendor.deliveract,
    PosVendor.marn,
    PosVendor.foodizone,
    PosVendor.tabsense,
];

export const usePOS = (isEnabled: boolean) => {
    const [hasPOS, setHasPOS] = useState(false);
    const [isSyncable, setIsSyncable] = useState(false);
    const { entitiesByVendor, canManagePosEntity } = useSelect((state) => ({
        entitiesByVendor: state.getPosEntitiesReducer.entitiesByVendor,
        canManagePosEntity: state.storeReducer.store.can_manage_pos_entity,
    }))
    useEffect(() => {
        if (!entitiesByVendor) {
            setHasPOS(false);
            return;
        }
        for (const vendor of Object.values(PosVendor)) {
            if (entitiesByVendor[vendor]) {
                setHasPOS(true);
                setIsSyncable(SYNCABLE_POS_VENDORS.includes(vendor));
                return;
            }
        }
    }, [entitiesByVendor]);

    return {
        hasPOS: isEnabled && hasPOS,
        isSyncable,
        canManagePosEntity,
    }
};
